import { createActionGroup, props } from '@ngrx/store';
import { CreateEnquiryInterface } from '../interface';

export const enquiryActions = createActionGroup({
  source: 'enquiry',
  events: {
    create: props<{ data: CreateEnquiryInterface }>(),
  },
});
